import { render, staticRenderFns } from "./BlocoDadosTerritorioMonitoramentoAgricola.vue?vue&type=template&id=09200fd0&scoped=true&lang=pug"
import script from "./BlocoDadosTerritorioMonitoramentoAgricola.vue?vue&type=script&lang=js"
export * from "./BlocoDadosTerritorioMonitoramentoAgricola.vue?vue&type=script&lang=js"
import style0 from "./BlocoDadosTerritorioMonitoramentoAgricola.vue?vue&type=style&index=0&id=09200fd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09200fd0",
  null
  
)

export default component.exports